/*
  Zaktualizowano pozycjonowanie panelu Warstw, aby pojawiał się pod widżetami po prawej stronie.
*/
import React from 'react';
import useLayerStore from '../store/useLayerStore';
import useSceneStore from '../store/useSceneStore';
import { TOOLS } from '../core/constants';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { clsx } from 'clsx';

const { FiLayers, FiEye, FiEyeOff, FiLock, FiUnlock, FiX } = FiIcons;

const LayersPanel = () => {
  const { tool, setTool } = useSceneStore();
  const { layers, toggleVisibility, toggleLock } = useLayerStore();

  if (tool !== TOOLS.LAYERS) return null;

  const layerOrder = ['furniture', 'shapes', 'texts', 'manualDimensions', 'roomLabels', 'logo', 'background', 'dimensions', 'grid'];

  return (
    <div className="absolute right-4 top-40 w-72 bg-white rounded-xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden z-50">
      <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiLayers} className="text-[#1E2937] text-lg" />
          <h3 className="font-semibold text-gray-700 text-sm">Warstwy</h3>
        </div>
        <button onClick={() => setTool(TOOLS.SELECT)} className="text-gray-400 hover:text-gray-600 p-1 hover:bg-gray-100 rounded-full transition-colors">
          <SafeIcon icon={FiX} className="text-sm" />
        </button>
      </div>
      <div className="p-2 space-y-1 max-h-[60vh] overflow-y-auto">
        {layerOrder.map((layerId) => {
          const layer = layers[layerId];
          if (!layer) return null;
          return (
            <div key={layerId} className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-lg transition-colors group">
              <div className="flex items-center gap-3"><span className="text-sm text-gray-700 font-medium">{layer.label}</span></div>
              <div className="flex items-center gap-1">
                <button onClick={() => toggleVisibility(layerId)} className={clsx("p-1.5 rounded-md transition-colors", layer.isVisible ? "text-gray-500 hover:bg-gray-200" : "text-gray-300 hover:text-gray-500 hover:bg-gray-100")} title={layer.isVisible ? "Ukryj" : "Pokaż"}>
                  <SafeIcon icon={layer.isVisible ? FiEye : FiEyeOff} className="text-sm" />
                </button>
                <button onClick={() => toggleLock(layerId)} className={clsx("p-1.5 rounded-md transition-colors", layer.isLocked ? "text-red-500 bg-red-50 hover:bg-red-100" : "text-gray-300 hover:text-gray-500 hover:bg-gray-100")} title={layer.isLocked ? "Odblokuj" : "Zablokuj"}>
                  <SafeIcon icon={layer.isLocked ? FiLock : FiUnlock} className="text-sm" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
      <div className="bg-gray-50 px-4 py-2 border-t border-gray-200 text-[10px] text-gray-500">Zablokowane warstwy nie mogą być edytowane</div>
    </div>
  );
};

export default LayersPanel;